import { render, staticRenderFns } from "./belegtypsearch.vue?vue&type=template&id=1a448710&scoped=true"
import script from "./belegtypsearch.vue?vue&type=script&lang=js"
export * from "./belegtypsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a448710",
  null
  
)

/* custom blocks */
import block0 from "./belegtypsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports